// extracted by mini-css-extract-plugin
export var avatarContainer = "_8l-0";
export var avatarTypingWave = "_8l-i";
export var gray = "_8l-f";
export var green = "_8l-c";
export var icon = "_8l-9";
export var image = "_8l-1";
export var lg = "_8l-6";
export var md = "_8l-5";
export var presenceDot = "_8l-b";
export var red = "_8l-d";
export var sm = "_8l-4";
export var status = "_8l-a";
export var typingDot = "_8l-h";
export var typingPill = "_8l-g";
export var xl = "_8l-7";
export var xs = "_8l-3";
export var xxl = "_8l-8";
export var xxs = "_8l-2";
export var yellow = "_8l-e";